import { render, staticRenderFns } from "./ServiceOnboarding.vue?vue&type=template&id=ded25628&"
import script from "./ServiceOnboarding.vue?vue&type=script&lang=js&"
export * from "./ServiceOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports